import React, { useState } from "react"
import { defPath, fetchPath } from '../config/defPath'
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {
    Navigation, Pagination
  } from 'swiper';
SwiperCore.use([Navigation, Pagination]);
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function App() {
    const anchorSliderNotice = async () => {
        const links = document.querySelectorAll('.boxMore__single') as NodeListOf<HTMLAnchorElement>
        links.forEach(link => {
            link.addEventListener('click', (e) =>{
                e.preventDefault()
                const target = link.dataset.text
                const text = link.querySelector('.boxMore__single__box--title') as HTMLElement
                target && localStorage.setItem('camila', target)
                window.dataLayer.push({
                    'event': 'GAEvent',
                    'event_category': 'Content',
                    'event_action': 'Button',
                    'event_label':  text?.textContent,
                    'interaction':'true',
                    'component_name': 'Modo_Carrera_Blog',
                    'element_text':  text?.textContent,
                });                  
                window.location.href = "/estadio-aguila/noticia"
            })
        });
    }

    const dataNew = async () => {

        const res = await fetch(`${fetchPath}/aguila/loyalty/news`)
        let dataRes = await res.json()

        const idNew:any = localStorage.getItem('camila')
        if (idNew) {
            if(res.status != 401){
                let index = dataRes.findIndex(function(el:any){
                    return el.id == idNew;
                });
    
                const title = document.querySelector('.titleI') as HTMLElement,
                    subtitle = document.querySelector('.subtitleI') as HTMLElement,
                    type = document.querySelector('.type') as HTMLElement,
                    titleArticule = document.querySelector('.titleC') as HTMLElement,
                    descArticule = document.querySelector('.descC') as HTMLElement,
                    bannerDesk = document.querySelector('.internNotice__content__top--bk') as HTMLImageElement,
                    bannerMob = document.querySelector('.internNotice__content__top--bk--mob') as HTMLSourceElement,
                    swiperWrapper = document.querySelector('.swiper-wrapper')
    
                    title.innerHTML = dataRes[index].titulo
                    subtitle.innerHTML = dataRes[index].fecha
                    type.innerHTML = dataRes[index].categoria
                    titleArticule.innerHTML = dataRes[index].subtitulo
                    descArticule.innerHTML = dataRes[index].description
                    bannerDesk.src = dataRes[index].banner_desktop.imgurl_raw
                    bannerDesk.alt = dataRes[index].banner_desktop.img_alt
                    bannerMob.srcset = dataRes[index].banner_mobile.imgurl_raw
    
                    if(dataRes.length >= 2){
                        dataRes.forEach((el:any, index:any) => {
                            if(el.id != idNew){
                                const title = el.titulo.replace(/((<\/\w+>|<\w+>))/ig, "")
                                if(swiperWrapper) swiperWrapper.innerHTML += `
                                <div class="swiper-slide">
                                    <a href="#" class="boxMore__single" data-text="${el.id}">
                                        <img class="boxMore__single--bk" src="${el.img_preview.imgurl_raw}" alt="${el.img_preview.img_alt}" />
                                        <div class="boxMore__single__box">
                                            <div class="boxMore__single__box--title">
                                                ${title.length > 30 ? el.titulo.substr(0, 30) + '...' : el.titulo}
                                            </div>
                                            <span class="type boxMore__single__box--type">${el.categoria}</span>
                                            <p class="boxMore__single__box--date">${el.fecha}</p>
                                        </div>
                                    </a>
                                </div>`
                            }
                        });

                        anchorSliderNotice()
                    }else{
                        document.querySelector('.titleB')?.classList.add('hide')
                    }
            }
        }else{
            window.location.href = "/estadio-aguila/noticias"
        }
    }

    var prevScrollPos = window.scrollY;
    
    React.useEffect(() => {
        dataNew()


        const toogleHeader = function() {
            var currentScrollPos = window.scrollY;
            
            if (prevScrollPos > currentScrollPos) {
                // Muestra el encabezado si el desplazamiento es hacia arriba
                document.querySelector(".newHeaderAL").classList.remove("scroll-opacity-out");
                document.querySelector(".newHeaderAL").classList.add("scroll-opacity-in");
            } else {
                // Oculta el encabezado si el desplazamiento es hacia abajo
                document.querySelector(".newHeaderAL").classList.add("scroll-opacity-out");
                document.querySelector(".newHeaderAL").classList.remove("scroll-opacity-in");
            }
            
            prevScrollPos = currentScrollPos;
        }

        window.addEventListener('scroll', toogleHeader)
        
        return () => {
            window.removeEventListener('scroll', toogleHeader)
        }

    }, [])

    const handleClick = (e:any, text:string) => {
        const titleNotice = document.querySelector('.titleI') as HTMLElement
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label':   text + " - " + titleNotice.innerText,// Jugar ahora - Qué ganas con Modo Aguila,
            'interaction':'true',
            'component_name': 'Modo_Carrera_Blog',
            'element_text':  e.target.innerText,
          });
                   
    }

    return (
        <>
            {/* Page HTML */}

            <section className="internNotice">
                
                <NewHeader />
                <Modal />
                <div className="internNotice__content">
                    <div className="internNotice__content__top">
                        <picture className="">
                            <source className="internNotice__content__top--bk--mob" media="(max-width: 767px)" srcSet={`${defPath}/assets/images/notice/decorationNM.png`}/>
                            <img className="internNotice__content__top--bk" src={`${defPath}/assets/images/internNotice/bkinternaNoticia.jpeg`} alt="" />
                        </picture>
                        <div className="internNotice__content__top--info">
                            <h1 className="titleI"></h1>
                            <p className="subtitleI"></p>
                            <span className="type"></span>
                        </div>
                        <a className="internNotice__content__top--back" href="#" onClick={() => window.location.href="/estadio-aguila/noticias"}><img src={`${defPath}/assets/images/internNotice/iconBack.png`} alt="" /> Volver</a>
                        <img className="iconStar1" src={`${defPath}/assets/images/icons/iconStars.png`} alt="" />
                        <img className="iconStar2" src={`${defPath}/assets/images/icons/iconStars.png`} alt="" />
                        <img className="iconStar3" src={`${defPath}/assets/images/icons/iconStars.png`} alt="" />
                    </div>
                    <div className="internNotice__content__middle">
                        <img className="iconStar" src={`${defPath}/assets/images/internNotice/icon1.png`} alt="" />
                        <img className="iconEl" src={`${defPath}/assets/images/internNotice/icon2.png`} alt="" />
                        <h2 className="titleC"></h2>
                        <div className="descC">
                            <p></p>
                        </div>
                        <a className="btnC" href="/estadio-aguila/instrucciones" onClick={(e) => handleClick(e, 'JUGAR AHORA')}>Jugar Ahora</a>
                    </div>
                    <div className="internNotice__content__bottom">
                        <img className="internNotice__content__bottom--bk" src={`${defPath}/assets/images/internNotice/bkmoreNotice.jpeg`} alt="" />
                        <img className="icon" src={`${defPath}/assets/images/internNotice/icon4.png`} alt="" />
                        <h2 className="titleB">Más Noticias</h2>
                        <div className="boxMore">
                        <Swiper
                            spaceBetween={15}
                            slidesPerView={1.1}
                            navigation={true}
                            pagination={{ clickable: true }}
                            breakpoints={{
                                991: {
                                  slidesPerView: 2.5,
                                  spaceBetween: 30,
                                },
                                1600:{
                                    slidesPerView: 3.5,
                                    spaceBetween: 50,
                                }
                            }}
                        >
                                                
                        </Swiper>
                            
                        </div>
                    </div>
                </div>
            </section>  
        </>
    )
}
export default App